import './App.css';
import Main from './Tour/Main';

function App() {
  return (
    <Main/>
  
  );
}

export default App;
